import {createAction, props} from '@ngrx/store';
import {Currency} from '../../models/Currencies';

export const saveCurrency = createAction(
  '[Currency] Save Currency',
  props<{ currency: Currency }>(),
);
